// extracted by mini-css-extract-plugin
export default {"RecoverRemovedItems__container":"styles_RecoverRemovedItems__container__mPSdZ","OrderItems__container":"styles_OrderItems__container__-3EvH"};